































import type { PropType } from '@nuxtjs/composition-api';
import {
  computed,
  defineComponent,
  useContext,
  useRouter
} from '@nuxtjs/composition-api';

import { hasUniqueCapacity } from '~/diptyqueTheme/helpers/product/attributes';
import {
  getProductCapacity,
  getProductVariantName
} from '~/diptyqueTheme/helpers/productGetters';
import type { CategoryInterface } from '~/modules/catalog/category/types';
import { useProduct } from '~/modules/catalog/product/composables/useProduct';
import productGetters from '~/modules/catalog/product/getters/productGetters';
import type { Product } from '~/modules/catalog/product/types';
import { ProductStockStatus } from '~/modules/GraphQL/types';

export default defineComponent({
  name: 'VaimoRelatedProductCard',
  components: {
    VaimoBanner: () => import('atoms/VaimoBanner.vue')
  },
  props: {
    item: {
      type: Object as PropType<Product | null>,
      required: true
    },
    currentProductSku: {
      required: true,
      type: String
    },
    simpleProductName: {
      required: false,
      type: String,
      default: ''
    }
  },
  setup(props) {
    const { getProductDetails } = useProduct();
    const router = useRouter();
    const { app } = useContext();

    const isActive = computed(() => {
      return props.item.sku === props.currentProductSku;
    });

    const getProductBySKU = async (): Promise<void> => {
      const result = await getProductDetails({
        filter: {
          sku: {
            eq: props.item.sku
          }
        }
      });
      const product = result?.items?.[0];
      const link = `${productGetters.getSlug(
        product as Product,
        product?.categories?.[0] as CategoryInterface
      )}`;

      await router.push(app.localePath(link));
    };

    const isOutOfStock = computed(
      () =>
        props.item.stock_status === ProductStockStatus.OutOfStock ||
        !props.item.is_salable
    );

    const variantName = computed(() => getProductVariantName(props.item));

    return {
      isActive,
      isOutOfStock,
      variantName,
      getProductBySKU,
      getProductCapacity,
      hasUniqueCapacity
    };
  }
});
